<template>
    <div class="contact">
        <!-- 页面标题 -->
        <section class="page-header">
            <div class="container">
                <h1 class="page-title">联系我们</h1>
                <div class="breadcrumb">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item>联系我们</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>

        <!-- 联系信息 -->
        <section class="contact-info">
            <div class="container">
                <div class="info-grid">
                    <div class="info-card" data-aos="fade-up">
                        <div class="icon-box">
                            <el-icon>
                                <Location />
                            </el-icon>
                        </div>
                        <h3>公司地址</h3>
                        <p>郑州航空港经济综合实验区华夏大道与慈航路交汇处中原数字视听产业园一期11号楼2楼221室</p>
                    </div>
                    <div class="info-card" data-aos="fade-up" data-aos-delay="100">
                        <div class="icon-box">
                            <el-icon>
                                <Phone />
                            </el-icon>
                        </div>
                        <h3>联系电话</h3>
                        <p>联系电话：400-9230-866</p>
                        <p><a href="tel:+8637155987845">0371-55987845</a></p>
                        <p>国际格式：+86 371 5598 7845</p>
                    </div>
                    <div class="info-card" data-aos="fade-up" data-aos-delay="200">
                        <div class="icon-box">
                            <el-icon>
                                <Message />
                            </el-icon>
                        </div>
                        <h3>电子邮箱</h3>
                        <p><a href="mailto:legal@mail.yunxuanwl.cn">法律业务：legal@mail.yunxuanwl.cn</a></p>
                        <p><a href="mailto:business@mail.yunxuanwl.cn">商务合作：business@mail.yunxuanwl.cn</a></p>
                        <p><a href="mailto:support@mail.yunxuanwl.cn">售后支持：support@mail.yunxuanwl.cn</a></p>
                    </div>
                    <div class="info-card" data-aos="fade-up" data-aos-delay="300">
                        <div class="icon-box">
                            <el-icon>
                                <Clock />
                            </el-icon>
                        </div>
                        <h3>工作时间</h3>
                        <p>周一至周五：9:00-18:00</p>
                        <p>节假日：需提前预约</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { Location, Phone, Message, Clock } from '@element-plus/icons-vue'
import AOS from 'aos'
import 'aos/dist/aos.css'

onMounted(() => {
    AOS.init({
        duration: 1000,
        once: true
    })
})
</script>

<style scoped lang="scss">
.contact {
    padding-top: 80px;

    .page-header {
        background: linear-gradient(135deg, #1890ff 0%, #604FDF 100%);
        padding: 60px 0;
        color: #fff;
        margin-bottom: 60px;

        .page-title {
            font-size: 36px;
            margin-bottom: 10px;
        }

        .breadcrumb {
            :deep(.el-breadcrumb) {
                color: rgba(255, 255, 255, 0.8);

                .el-breadcrumb__item {
                    .el-breadcrumb__inner {
                        color: rgba(255, 255, 255, 0.8);

                        &:hover {
                            color: #fff;
                        }
                    }

                    &:last-child .el-breadcrumb__inner {
                        color: #fff;
                    }
                }
            }
        }
    }

    .contact-info {
        padding: 0 0 80px;

        .info-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 30px;

            .info-card {
                background: #fff;
                padding: 40px 30px;
                border-radius: 12px;
                text-align: center;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
                transition: transform 0.3s;

                &:hover {
                    transform: translateY(-10px);

                    .icon-box {
                        background: var(--el-color-primary);
                        color: #fff;
                    }
                }

                .icon-box {
                    width: 80px;
                    height: 80px;
                    margin: 0 auto 20px;
                    background: #f0f5ff;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: var(--el-color-primary);
                    transition: all 0.3s;

                    .el-icon {
                        font-size: 32px;
                    }
                }

                h3 {
                    font-size: 20px;
                    color: #333;
                    margin-bottom: 15px;
                }

                p {
                    font-size: 14px;
                    color: #666;
                    line-height: 1.8;

                    a {
                        color: var(--el-color-primary);
                        text-decoration: none;
                    }
                }
            }
        }
    }
}

@media (max-width: 1200px) {
    .contact {
        .contact-info {
            .info-grid {
                grid-template-columns: repeat(2, 1fr);
            }
        }
    }
}

@media (max-width: 768px) {
    .contact {
        .page-header {
            padding: 40px 0;

            .page-title {
                font-size: 28px;
            }
        }

        .contact-info {
            .info-grid {
                grid-template-columns: 1fr;
            }
        }
    }
}
</style>
